var isMobile = false;

jQuery(document).ready(function () {
    mobile_checkSize(jQuery(window).width());

    jQuery(window).bind("resize", function () {
        mobile_checkSize(jQuery(window).width());
    });
});

function mobile_checkSize(width) {
    if (width < 1300) {
        if (!isMobile) {
            isMobile = true;

            jQuery('.aya .arrow_trig').on('click', function (e) {

                var dropdown = jQuery(this).parent().parent().parent().find('.dropdown');

                if (dropdown.css('visibility') == 'visible') {
                    jQuery(this).removeClass('rotate_after');
                    dropdown.css('visibility', 'hidden');
                    dropdown.css('opacity', '0');
                    dropdown.css('height', '0');
                    dropdown.css('display', 'none');
                } else {
                    jQuery(this).addClass('rotate_after');
                    dropdown.addClass('dropdown_show');
                    dropdown.css('visibility', 'visible');
                    dropdown.css('opacity', '1');
                    dropdown.css('height', 'auto');
                    dropdown.css('display', 'block');
                }

                return false;
            });


            jQuery('.middleNavItem .arrow_trig, .third_menu .arrow_trig').on('click', function (e) {

                var dropdown = jQuery(this).parent().children('.dropdown');

                if (dropdown.css('visibility') == 'visible') {
                    jQuery(this).removeClass('rotate_after');
                    dropdown.css('visibility', 'hidden');
                    dropdown.css('opacity', '0');
                    dropdown.css('height', '0');
                    dropdown.css('display', 'none');

                } else {
                    jQuery(this).addClass('rotate_after');
                    dropdown.addClass('dropdown_show');
                    dropdown.css('visibility', 'visible');
                    dropdown.css('opacity', '1');
                    dropdown.css('height', 'auto');
                    dropdown.css('display', 'block');
                }

                return false;
            });

            jQuery('.menu-item-has-children, .topNavItem').find('a').on('click', function (e) {
                /* This stops child a's from triggering parent li's function */
                if (!jQuery(this).parent().hasClass('menu-item-has-children')) {
                    e.stopPropagation();
                }

                return true;
            });


            jQuery('.menu-item-has-children, .topNavItem').find('.dropdown').css('visibility', 'hidden');

        }
    } else {
        isMobile = false;

        jQuery('.menu-item-has-children, .topNavItem').find('.dropdown').css('visibility', '');

        jQuery('.menu-item-has-children, .topNavItem').each(function (index) {
            var dropdown = jQuery(this).find('.dropdown').first();

            jQuery(this).removeClass('rotate_after');
            dropdown.removeClass('dropdown_show');
            dropdown.css('visibility', '');
            dropdown.css('opacity', '');
            dropdown.css('height', '');
        });
    }
    jQuery('#openMenu11').on('click', function openMenu() {

        jQuery('.get-started-mobile').toggleClass('hidden');
        jQuery(this).toggleClass('active');

        jQuery('html').toggleClass('menu-opened');
        jQuery('body').toggleClass('menu-opened');
        /*var topNav = jQuery('.topNav');
        var middleNav = jQuery('.middleNav');
        var topMiddle = jQuery('.topMiddle');

        if (topMiddle.is(':visible')) {
            topNav.hide();
            middleNav.hide();
            topMiddle.hide();
        } else {
            topNav.show();
            middleNav.show();
            topMiddle.show();
        }*/
        var mobileSiteMenu = jQuery('.mobileSiteMenu');
        if (mobileSiteMenu.is(':visible')) {
            mobileSiteMenu.hide();
        } else {
            mobileSiteMenu.show();
        }
    });

}
